export default __webpack_public_path__ + "static/media/pan-2.8800070e.png";